import { defineStore } from 'pinia'
import { ref } from 'vue'
import { healthApi } from '@/api/client'

export const useAppStore = defineStore('app', () => {
  const environment = ref('loading...')

  async function fetchEnvironment() {
    try {
      const health = await healthApi.get()
      environment.value = health.env
    } catch {
      environment.value = 'unknown'
    }
  }

  return { environment, fetchEnvironment }
})
